import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03d354ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }

import Prosperity from "./components/Prosperity/index.vue";
import HomeInfo from "./components/HomeInfo/index.vue";
import AncientCity from "./components/AncientCity/index.vue";
import GameFeatures from "./components/GameFeatures/index.vue";
import Celebrity from "./components/Celebrity/index.vue";
import GamingCommunity from "./components/GamingCommunity/index";
import FloatingWindow from "@/components/PcComponents/FloatingWindow/index.vue";
import FooterCopyright from "@/components/PcComponents/FooterCopyright/index.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Suspense, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Prosperity),
        _createVNode(HomeInfo),
        _createVNode(AncientCity),
        _createVNode(Celebrity),
        _createVNode(GameFeatures),
        _createVNode(_unref(GamingCommunity)),
        _createVNode(FloatingWindow),
        _createVNode(FooterCopyright)
      ])
    ]),
    _: 1
  }))
}
}

})